// Supplier display name for a store-editor campaign product -- the ONE rule
// both ProductCard.vue and ProductsTableView.vue read, so the card and the
// table can never disagree on which supplier a product shows.
//
// Precedence (Jake 2026-10-05):
//   1. supplier.name -- the vendor joined through campaign_products.supplier_id
//      (_row_to_product_dict in api/src/endpoints/product.py), i.e. the
//      vendor's CURRENT name.
//   2. supplier_name -- the name persisted on the campaign product row.
//   3. null -- the caller renders a neutral placeholder, never invented text.
function nonBlank(value) {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function supplierLabel(cp) {
  if (!cp) return null;
  return nonBlank(cp.supplier && cp.supplier.name) || nonBlank(cp.supplier_name);
}
